var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledCaretUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_999_7791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3841 12.059L11.1341 5.80904C11.076 5.75093 11.0071 5.70483 10.9312 5.67337C10.8554 5.64192 10.774 5.62573 10.6919 5.62573C10.6098 5.62573 10.5284 5.64192 10.4526 5.67337C10.3767 5.70483 10.3078 5.75093 10.2497 5.80904L3.99971 12.059C3.9122 12.1464 3.8526 12.2579 3.82844 12.3792C3.80429 12.5005 3.81666 12.6262 3.86401 12.7405C3.91135 12.8547 3.99154 12.9524 4.09441 13.021C4.19728 13.0897 4.31821 13.1263 4.4419 13.1262H16.9419C17.0656 13.1263 17.1865 13.0897 17.2894 13.021C17.3923 12.9524 17.4724 12.8547 17.5198 12.7405C17.5671 12.6262 17.5795 12.5005 17.5554 12.3792C17.5312 12.2579 17.4716 12.1464 17.3841 12.059Z",
    fill: "#888888"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_999_7791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.691895 0.0012207)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledCaretUp);
export default __webpack_public_path__ + "static/media/filled-caret-up.2dae115576deca8a88dd907cbde9f7ba.svg";
export { ForwardRef as ReactComponent };